import React, {useEffect, useState} from "react";
import {getResource} from "../../service/http-service";
import './ProfileSegmentStyle.css'
import {GenericEditModalForm} from "./GenericEditModalForm";
import {DateLabelFormatter} from "../../ui/DateLabelFormatter";

export const ProfileAdditionalInformationSegment = ({candidate, isPreview, setUpdateCandidate, updateCandidate}) => {


    const [entity, setEntity] = useState({candidate});
    const [addEntity, setAddEntity] = useState(false);
    const [updateEntity, setUpdateEntity] = useState(false)
    const [candidateRecruitmentsList, setCandidateRecruitmentsList] = useState([])

    const getAppliedRecruitments = () => {
        getResource('candidates/get_applied_recruitment_for_logged_user').then((data) => {
            setCandidateRecruitmentsList(data.data)
        })
    }

    useEffect(() => {
        getResource('candidates/get_logged_user_candidate').then(data => {
            setEntity(data.data);
            getAppliedRecruitments();
        })

    }, [updateEntity])



    return(
        <div className='profile_segment_main_container'>
            {(entity) &&
                <div className='profile_segment_separate_info'>
                    <h5>Очекувана нето плата: <span>{entity.expectedSalary}  &euro;</span></h5>
                    <h5>Дали ви одговара работа во три смени: <span>{entity.workInThreeShifts === true ? "Да" : (entity.workInThreeShifts === false ? "Не" : "")}</span></h5>
                    <h5>Дали ви одговара работа во две смени: <span>{entity.workInTwoShifts === true ? "Да" : (entity.workInTwoShifts === false ? "Не" : "")}</span></h5>
                    <h5>Хоби и интереси: <span>{entity.hobbies}</span></h5>
                    <h5>Опишете се себеси: <span>{entity.selfDescription}</span></h5>
                    <h5>Останато: <span> {entity.otherInformation}</span></h5>
                    <h5>Како дознавте за нас: <span>{entity.referralOrigin && entity.referralOrigin.name}</span></h5>
                    <h5>Датум на потврда на профил: <span>  <DateLabelFormatter dateString={entity.user && entity.user.dateOfConfirmation}/></span></h5>
                    <h5>Датум на последно ажурирање: <span>  <DateLabelFormatter dateString={entity.lastUpdateDate}/></span></h5>
                    <h5>Огласи на кои сум аплицирал:</h5>
                        <ul>{(candidateRecruitmentsList && candidateRecruitmentsList.length > 0) &&
                            candidateRecruitmentsList.map(item => <li>{item.recruitment.name}</li>)}</ul>
                </div>}


                    <div className='profile_footer_container'>
                        <hr/>
                        {(!isPreview &&  !addEntity) && (<div className="profile_add_button mt-3"
                                                               onClick={() =>
                                                               {setEntity({entity})
                                                                   setAddEntity(true)}}
                        >Промени преференци</div>)}
                        {addEntity === true && (<div className="open-form"> <GenericEditModalForm
                            type="ADDITIONAL_INFORMATION"
                            title= {"Промени преференци"}
                            entity={entity} setEntity={setEntity}
                            addEntity={addEntity} setAddEntity={setAddEntity}
                            updateEntity={updateEntity} setUpdateEntity={setUpdateEntity}
                            setUpdateCandidate={setUpdateCandidate} updateCandidate={updateCandidate}
                        /></div>)}
                    </div>
        </div>
    )
}